import {LayoutConfigModel} from '../_base/layout';
import { environment } from '../../../environments';

export class LayoutConfig {
	public defaults: LayoutConfigModel = {
		'demo': 'demo4',
		// == Base Layout
		'self': {
			'layout': 'fluid', // fluid|boxed
			'body': {
				'background-image': environment.assets.mainBackground,
				'background-position': 'center top',
				'background-size': '100% 350px',
			},
			'logo': environment.assets.brandLogo,
		},
		// == Page Splash Screen loading
		'loader': {
			'enabled': true,
			'type': 'spinner-logo',
			'logo': environment.assets.splashLogo,
			'message': 'Please wait...',
		},
		// == Colors for javascript
		'colors': {
			'state': {
				'brand': '#D04A02',
				'light': '#ffffff',
				'dark': '#282a3c',
				'primary': '#5867dd',
				'success': '#34bfa3',
				'info': '#36a3f7',
				'warning': '#ffb822',
				'danger': '#fd3995',
			},
			'base': {
				'label': [
					'#c5cbe3',
					'#a1a8c3',
					'#3d4465',
					'#3e4466',
				],
				'shape': [
					'#f0f3ff',
					'#d9dffa',
					'#afb4d4',
					'#646c9a',
				],
			},
		},
		'header': {
			'self': {
				'width': 'fluid',
				'fixed': {
					'desktop': {
						'enabled': true,
						'mode': 'menu',
					},
					'mobile': true,
				},
			},
			'menu': {
				'self': {
					'display': true,
					'root-arrow': true,
				},
				'desktop': {
					'arrow': true,
					'toggle': 'click',
					'submenu': {
						'skin': 'light',
						'arrow': true,
					},
				},
				'mobile': {
					'submenu': {
						'skin': 'dark',
						'accordion': true,
					},
				},
			},
		},
		'subheader': {
			'display': true,
			'layout': 'subheader-v4',
			'width': 'fluid',
			'style': 'transparent',
		},
		'content': {
			'width': 'fluid',
		},
		'footer': {
			'self': {
				'width': 'fluid',
				'layout': 'extended',
			},
		},
	};

	/**
	 * Good place for getting the remote config
	 */
	public get configs(): LayoutConfigModel {
		return this.defaults;
	}
}
